"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuid = exports.randomNumber = void 0;
var randomNumber = function (min, max) {
    return min + Math.floor(Math.random() * max - min);
};
exports.randomNumber = randomNumber;
var uuid = function () {
    var d = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line:no-bitwise
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        // tslint:disable-next-line:no-bitwise
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
};
exports.uuid = uuid;
//# sourceMappingURL=index.js.map